import SignIn from './SignIn'
import { useNavigate } from 'react-router-dom'

export default function SignInPage() {
  const navigate = useNavigate()

  // Don't auto-redirect - let the SignIn component handle navigation
  // This prevents race conditions with the biometric enrollment prompt
  // useEffect(() => {
  //   if (!loading && user) {
  //     navigate('/app')
  //   }
  // }, [user, loading, navigate])

  const handleClose = () => {
    // Do nothing - let the SignIn component handle navigation
    // This page will be unmounted when navigation happens anyway
  }

  const handleSwitchToRegister = () => {
    navigate('/register')
  }

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50/30 overflow-hidden">
      {/* Floating gradient orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-br from-indigo-400/20 to-purple-400/20 rounded-full blur-3xl animate-float" />
        <div className="absolute top-1/3 -left-32 w-80 h-80 bg-gradient-to-br from-blue-400/20 to-cyan-400/20 rounded-full blur-3xl animate-float-delayed" />
        <div className="absolute bottom-20 right-1/4 w-72 h-72 bg-gradient-to-br from-purple-400/15 to-pink-400/15 rounded-full blur-3xl animate-float" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <SignIn
          isOpen={true}
          onClose={handleClose}
          onSwitchToRegister={handleSwitchToRegister}
        />
      </div>
    </div>
  )
}